module.exports = __webpack_public_path__ + "static/media/4-diy-guide-prevent-sexual-assault.19f45c47.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/4-diy-guide-prevent-sexual-assault.pdf
// module id = 158
// module chunks = 0